import { PAGES } from "@dune/types";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useMe } from "../api/queries/users.queries";
import { checkBrokerAccess } from "../utils/brokerAccessUtils";

export const BrokerRequireCompleteRegistration = () => {
	const { me, isLoading: isMeLoading } = useMe();
	const [accessCheck, setAccessCheck] = useState<{
		canAccessApp: boolean;
		redirectTo: string;
		brokerStatus: string | null | undefined;
	} | null>(null);
	const [isCheckingAccess, setIsCheckingAccess] = useState(false);

	useEffect(() => {
		const checkAccess = async () => {
			if (!isMeLoading && me?.role === "BROKER") {
				setIsCheckingAccess(true);
				try {
					const result = await checkBrokerAccess();
					setAccessCheck(result);
				} catch {
					setAccessCheck({
						canAccessApp: false,
						redirectTo: PAGES.REGISTER_BROKER_SECOND_STEP.index,
						brokerStatus: null,
					});
				} finally {
					setIsCheckingAccess(false);
				}
			} else if (!isMeLoading && me?.role !== "BROKER") {
				setAccessCheck({
					canAccessApp: true,
					redirectTo: PAGES.ROOT,
					brokerStatus: null,
				});
			}
		};

		checkAccess();
	}, [isMeLoading, me?.role]);

	if (isMeLoading || isCheckingAccess) {
		return (
			<div className="flex items-center justify-center h-screen">
				<h1 className="text-3xl font-semibold">Vérification des accès...</h1>
			</div>
		);
	}

	if (accessCheck && !accessCheck.canAccessApp) {
		return <Navigate to={accessCheck.redirectTo} replace />;
	}

	return <Outlet />;
};
